import { useContext } from "react";
import { EditorContext } from "../EditorCommon/EditorContext";

export function BarCountSelector(props: { doorIndex: number }) {

    const ec = useContext(EditorContext);

    const display = ec.cabinetService.getDoorProduct()?.bars.length ?? 0 > 1;
    if (!display)
        return null;

    const options = ec.cabinetService.getDoorProduct()?.bars
        .map(bar => (
            <option key={bar.id} value={bar.id}>
                {bar.name}
            </option>
        ));

    if (!options || options.length < 2)
        return null;

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const barId = parseInt(evt.target.value);
        ec.cabinetService.setBar(props.doorIndex, barId);
    }

    return (
        <div className="form-group bar-count-selector">
            <label htmlFor="bar-count-selector-select">
                {ec.translator("doors bar count", "Antal sprosser: ")}
            </label>
            <select onChange={onChange}
                value={ec.cabinet.doors[props.doorIndex].barId ?? undefined}
                id="bar-count-selector-select"
                className="form-control"
            >
                {options}
            </select>
        </div>
    )
}
